import React from "react";
import { useTranslation } from "react-i18next";
import DocList from "./DocList";

// Retailer -- matches Diamond-PO-Prototype-v3.html's r-pos screen (line 805). Named
// "DiamondPurchaseOrders" to avoid colliding with the existing jewelry PurchaseOrder.js.
export const DiamondPurchaseOrders = () => {
  const { t } = useTranslation();
  return <DocList title={t("Purchase Orders")} description={t("Direct purchases and stones bought off memo")} kind="PO" whoColumn={t("Supplier")} whoField="SupplierName" />;
};

export default DiamondPurchaseOrders;
